(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["p7-finder"] && !Shopify.designMode) return;
  try {
    
function exactModelQuery(raw) {
 const text=raw.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/pro\s*max/g,'pro max').replace(/\b([sa])\s+(\d{2})\b/g,'$1$2').replace(/\+/g,' plus ').replace(/\s+/g,' ').trim();
 if(/[":]|\b(?:AND|OR|NOT)\b/.test(raw)) return raw;
 const iphone=text.match(/\b(?:iphone\s*)?(1[1-7])\s*(pro max|pro|plus|mini)?\b/);
 const samsung=text.match(/\b(s\d{2}|a\d{2}|note\s*\d{1,2})\s*(ultra|plus|fe)?\b/);
 const match=samsung||iphone;if(!match)return raw.trim();
 const family=samsung?'samsung':'iphone';const model=match[1].replace(/\s+/g,' ');const edition=(match[2]||'').trim();
 const wanted=(family+' '+model+' '+edition).trim().split(/\s+/).map(word=>'title:"'+word+'"');
 const excluded=(samsung?['ultra','plus','fe']:['pro','max','plus','mini']).filter(word=>!edition.split(' ').includes(word));
 const rest=text.replace(match[0],' ').replace(/\b(iphone|samsung|galaxy|para|de|el|un|una|forro|forros|funda|fundas|carcasa|carcasas)\b/g,' ').trim();
 if(/\b(forros?|fundas?|carcasas?)\b/.test(text))wanted.push('title:forro');
 if(rest)wanted.push(...rest.split(/\s+/).map(word=>'title:"'+word.replace(/[^a-z0-9-]/g,'')+'"').filter(word=>word!=='title:""'));
 return wanted.concat(excluded.map(word=>'-title:"'+word+'"')).join(' ');
}
if(typeof document!=='undefined') {
 document.querySelectorAll('form[data-p7-exact-search]').forEach(form=>{
  if(form.dataset.p7Bound)return;form.dataset.p7Bound='true';
  const input=form.querySelector('[name="q"]');if(!input)return;
  const original=new URLSearchParams(location.search).get('p7_text');
  if(input.tagName==='INPUT'&&original!==null)input.value=original;
  form.addEventListener('submit',()=>{
   const raw=input.value.replace(/^"|"$/g,'');const query=exactModelQuery(raw);
   let plain=form.querySelector('[name="p7_text"]');if(!plain){plain=document.createElement('input');plain.type='hidden';plain.name='p7_text';form.append(plain)}plain.value=raw;
   let q=form.querySelector('[data-p7-query]');if(!q){q=document.createElement('input');q.type='hidden';q.name='q';q.dataset.p7Query='';form.append(q)}q.value=query;input.removeAttribute('name');
  });
 });
}

function initP7BrandFinder(){document.querySelectorAll('.p7-brand-tabs').forEach(tabs=>{if(tabs.dataset.ready)return;tabs.dataset.ready='true';tabs.addEventListener('click',event=>{const button=event.target.closest('[data-p7-brand]');if(!button)return;const select=tabs.parentElement.querySelector('select');tabs.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));Array.from(select.options).forEach(option=>{option.hidden=Boolean(option.value&&button.dataset.p7Brand!=='all'&&!option.value.startsWith(button.dataset.p7Brand));option.disabled=option.hidden;});select.value='';});});}initP7BrandFinder();document.addEventListener('shopify:section:load',initP7BrandFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p7-product"]) return;
  try {
    
function initP7Product(){
 document.querySelectorAll('[data-p7-product]').forEach(root=>{
  if(root.dataset.galleryReady)return;root.dataset.galleryReady='true';
  const select=root.querySelector('#p7-variant'),track=root.querySelector('.pdp-image'),thumbs=[...root.querySelectorAll('[data-src]')];
  let active=0;
  const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(track&&thumbs.length){
   active=Math.max(0,thumbs.findIndex(b=>b.getAttribute('aria-pressed')==='true'));
   const original=track.querySelector('img');

   const slides=thumbs.map((button,i)=>{const slide=document.createElement('div');slide.className='p7-photo-slide';const img=document.createElement('img');img.src=button.dataset.src;img.alt=button.getAttribute('aria-label')||'';img.width=1200;img.height=1200;img.loading=i===active?'eager':'lazy';img.draggable=false;if(i===active&&original){img.src=original.src;if(original.srcset)img.srcset=original.srcset;if(original.sizes)img.sizes=original.sizes;}slide.append(img);return slide;});
   track.replaceChildren(...slides);track.classList.add('p7-photo-track');track.tabIndex=0;track.setAttribute('role','group');track.setAttribute('aria-label',root.querySelector('h1')?.textContent||'');
   const sync=()=>thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===active)));
   const go=(index,instant=false)=>{active=Math.max(0,Math.min(slides.length-1,index));track.scrollTo({left:active*track.clientWidth,behavior:instant||reduced()?'instant':'smooth'});sync();};
   root.p7SelectPhoto=src=>{const index=thumbs.findIndex(b=>b.dataset.src===src);if(index>=0)go(index);};
   thumbs.forEach((button,i)=>button.addEventListener('click',()=>go(i)));
   track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(active+(event.key==='ArrowRight'?1:-1));}});
   let frame=0;track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{if(track.clientWidth){active=Math.round(track.scrollLeft/track.clientWidth);sync();}});},{passive:true});
   const resize=new ResizeObserver(()=>go(active,true));resize.observe(track);
   root.p7GalleryCleanup=()=>{resize.disconnect();cancelAnimationFrame(frame);};go(active,true);
  }
  root.querySelectorAll('[data-p7-variant]').forEach(pill=>pill.addEventListener('click',()=>{if(pill.disabled)return;select.value=pill.dataset.p7Variant;select.dispatchEvent(new Event('change',{bubbles:true}));}));
  select?.addEventListener('change',()=>{root.querySelectorAll('[data-p7-variant]').forEach(pill=>pill.setAttribute('aria-pressed',String(pill.dataset.p7Variant===select.value)));const option=select.selectedOptions[0],button=root.querySelector('#p7-add');root.querySelector('#p7-price').textContent=option.dataset.price;button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.unavailableLabel:button.dataset.availableLabel;if(option.dataset.image)root.p7SelectPhoto?.(option.dataset.image);const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);});
 });
}
initP7Product();document.addEventListener('shopify:section:load',initP7Product);document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll('[data-p7-product]').forEach(root=>root.p7GalleryCleanup?.());});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p7-reels"] && !Shopify.designMode) return;
  try {
    
function initP7Reels(){
  document.querySelectorAll('[data-p7-reels]').forEach(section=>{
    if(section.dataset.p7ReelsReady)return;
    section.dataset.p7ReelsReady='true';
    const track=section.querySelector('[data-p7-reels-track]');
    const move=direction=>track.scrollBy({left:direction*track.clientWidth*.84,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    section.querySelector('[data-p7-reels-previous]')?.addEventListener('click',()=>move(-1));
    section.querySelector('[data-p7-reels-next]')?.addEventListener('click',()=>move(1));
    const loadVideo=video=>{
      if(video.dataset.p7Loaded)return;
      video.querySelectorAll('source[data-src]').forEach(source=>{
        source.src=source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.p7Loaded='true';
      video.load();
    };
    const playVideo=video=>{
      const play=()=>video.play().catch(()=>{});
      if(video.readyState>=2)play();
      else video.addEventListener('canplay',play,{once:true});
    };
    if('IntersectionObserver'in window){
      const observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){
            loadVideo(entry.target);
            playVideo(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },{rootMargin:'300px 160px',threshold:.01});
      section.querySelectorAll('[data-p7-lazy-video]').forEach(video=>observer.observe(video));
    }else{
      section.querySelectorAll('[data-p7-lazy-video]').forEach(loadVideo);
    }
  });
}
initP7Reels();
document.addEventListener('shopify:section:load',initP7Reels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p7-search"]) return;
  try {
    
function exactModelQuery(raw) {
 const text=raw.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/pro\s*max/g,'pro max').replace(/\b([sa])\s+(\d{2})\b/g,'$1$2').replace(/\+/g,' plus ').replace(/\s+/g,' ').trim();
 if(/[":]|\b(?:AND|OR|NOT)\b/.test(raw)) return raw;
 const iphone=text.match(/\b(?:iphone\s*)?(1[1-7])\s*(pro max|pro|plus|mini)?\b/);
 const samsung=text.match(/\b(s\d{2}|a\d{2}|note\s*\d{1,2})\s*(ultra|plus|fe)?\b/);
 const match=samsung||iphone;if(!match)return raw.trim();
 const family=samsung?'samsung':'iphone';const model=match[1].replace(/\s+/g,' ');const edition=(match[2]||'').trim();
 const wanted=(family+' '+model+' '+edition).trim().split(/\s+/).map(word=>'title:"'+word+'"');
 const excluded=(samsung?['ultra','plus','fe']:['pro','max','plus','mini']).filter(word=>!edition.split(' ').includes(word));
 const rest=text.replace(match[0],' ').replace(/\b(iphone|samsung|galaxy|para|de|el|un|una|forro|forros|funda|fundas|carcasa|carcasas)\b/g,' ').trim();
 if(/\b(forros?|fundas?|carcasas?)\b/.test(text))wanted.push('title:forro');
 if(rest)wanted.push(...rest.split(/\s+/).map(word=>'title:"'+word.replace(/[^a-z0-9-]/g,'')+'"').filter(word=>word!=='title:""'));
 return wanted.concat(excluded.map(word=>'-title:"'+word+'"')).join(' ');
}
if(typeof document!=='undefined') {
 document.querySelectorAll('form[data-p7-exact-search]').forEach(form=>{
  if(form.dataset.p7Bound)return;form.dataset.p7Bound='true';
  const input=form.querySelector('[name="q"]');if(!input)return;
  const original=new URLSearchParams(location.search).get('p7_text');
  if(input.tagName==='INPUT'&&original!==null)input.value=original;
  form.addEventListener('submit',()=>{
   const raw=input.value.replace(/^"|"$/g,'');const query=exactModelQuery(raw);
   let plain=form.querySelector('[name="p7_text"]');if(!plain){plain=document.createElement('input');plain.type='hidden';plain.name='p7_text';form.append(plain)}plain.value=raw;
   let q=form.querySelector('[data-p7-query]');if(!q){q=document.createElement('input');q.type='hidden';q.name='q';q.dataset.p7Query='';form.append(q)}q.value=query;input.removeAttribute('name');
  });
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p7-styles"]) return;
  try {
    
(()=>{
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  let observer=null,frame=0,hero=null,parallaxTimer=0;
  const pending=new Set();
  function clear(){observer?.disconnect();pending.forEach(el=>el.classList.remove('p7-pending'));pending.clear();clearTimeout(parallaxTimer);hero?.classList.remove('p7-parallax');}
  function refresh(){
    clear();hero=document.querySelector('.hero-image');
    if(reduce.matches)return;
    if('IntersectionObserver' in window){
      observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('p7-pending');pending.delete(entry.target);observer.unobserve(entry.target);}}),{threshold:.08,rootMargin:'0px 0px -24px 0px'});
      document.querySelectorAll('.section-head,.category-card,.product-card,.finder,.editorial-card,.local-block>div,.about-grid>div,.help-card,.faq,.pdp-copy').forEach((el,index)=>{
        el.classList.add('p7-reveal');el.style.setProperty('--p7-delay',Math.min(index%4*45,135)+'ms');
        if(el.getBoundingClientRect().top>innerHeight*.82){el.classList.add('p7-pending');pending.add(el);observer.observe(el);}
      });
    }
    if(hero&&matchMedia('(min-width:901px) and (pointer:fine)').matches){parallaxTimer=setTimeout(()=>{hero?.classList.add('p7-parallax');tick();},1700);}
  }
  function tick(){
    frame=0;document.querySelector('.header')?.classList.toggle('is-scrolled',scrollY>12);
    if(!hero||reduce.matches||!hero.classList.contains('p7-parallax'))return;
    const box=hero.getBoundingClientRect();if(box.bottom>0&&box.top<innerHeight)hero.style.setProperty('--p7-drift',Math.max(-10,Math.min(10,-box.top*.025))+'px');
  }
  addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(tick);},{passive:true});
  addEventListener('pageshow',()=>{document.body.classList.remove('p7-leaving');refresh();});
  reduce.addEventListener('change',refresh);
  document.addEventListener('shopify:section:load',refresh);
  window.P7Motion={refresh,reduced:()=>reduce.matches};
  document.addEventListener('click',event=>{const link=event.target.closest('a');if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target||link.hasAttribute('download')||reduce.matches||'startViewTransition' in document)return;const dest=new URL(link.href,location.href);if(dest.origin===location.origin&&dest.pathname!==location.pathname){document.body.classList.add('p7-leaving');setTimeout(()=>document.body.classList.remove('p7-leaving'),900);}});
  tick();refresh();
})();


  } catch(e) { console.error(e); }
})();
})();
